import { DIVIPOLA_DEPARTMENTS, DIVIPOLA_MUNICIPALITIES } from './divipola-data.js';
export { DIVIPOLA_DEPARTMENTS, DIVIPOLA_MUNICIPALITIES };
/** Sin tildes, en minúscula y con un solo espacio, para comparar nombres como los escriben los autos. */
export const foldName = (s) => s.normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase().replace(/[.,]/g, '').replace(/\s+/g, ' ').trim();
const byCode = new Map(DIVIPOLA_MUNICIPALITIES.map((m) => [m.code, m]));
const departmentsByCode = new Map(DIVIPOLA_DEPARTMENTS.map((d) => [d.code, d]));
const municipalitiesByName = new Map();
for (const m of DIVIPOLA_MUNICIPALITIES) {
    const k = foldName(m.name);
    municipalitiesByName.set(k, [...(municipalitiesByName.get(k) ?? []), m]);
}
/** Todos los municipios con ese nombre («Villanueva» hay cuatro), para preguntar en cuál está el despacho. */
export const municipalitiesNamed = (city) => (city ? municipalitiesByName.get(foldName(city).replace(/\s+dc$/, '')) ?? municipalitiesByName.get(foldName(city)) ?? [] : []);
export const municipalityByCode = (code) => (code ? byCode.get(code) : undefined);
/** Municipios de un departamento, en orden alfabético (para el selector en cascada). */
export const municipalitiesOfDepartment = (departmentCode) => (departmentCode ? DIVIPOLA_MUNICIPALITIES.filter((m) => m.code.startsWith(departmentCode)).sort((a, b) => a.name.localeCompare(b.name, 'es')) : []);
export const departmentByCode = (code) => (code ? departmentsByCode.get(code.slice(0, 2)) : undefined);
/** El departamento de un municipio: los dos primeros dígitos de su código. */
export const departmentOfMunicipality = (municipalityCode) => departmentByCode(municipalityCode);
/** «Tuluá, Valle del Cauca», o el código cuando no está en la lista. */
export function municipalityLabel(code) {
    const m = municipalityByCode(code);
    if (!m)
        return code ?? '';
    const d = departmentOfMunicipality(code);
    return d && foldName(d.name) !== foldName(m.name) ? `${m.name}, ${d.name}` : m.name;
}
/** El departamento de la lista que corresponde a un texto («VALLE DEL CAUCA», «Bogota», «departamento de Boyacá»), o undefined. */
export function matchDepartment(text) {
    if (!text)
        return undefined;
    const t = foldName(text).replace(/^(departamento\s+(de|del)\s+)/, '').replace(/\s+dc$/, '');
    return DIVIPOLA_DEPARTMENTS.find((d) => foldName(d.name).replace(/\s+dc$/, '') === t);
}
/**
 * El municipio que corresponde a un nombre de ciudad, con el departamento como pista. Un nombre único (Tuluá, Bucaramanga)
 * se reconoce solo; uno repetido (hay varios «Villanueva», «Sabanalarga», «Argelia») solo con el departamento. Sin
 * certeza, undefined: mejor no ubicar que ubicar mal.
 */
export function matchMunicipality(city, departmentHint) {
    if (!city)
        return undefined;
    const options = municipalitiesByName.get(foldName(city).replace(/\s+dc$/, '')) ?? municipalitiesByName.get(foldName(city)) ?? [];
    if (!options.length) {
        // «Miraflores Boyacá», «Tuluá - Valle del Cauca», «Villanueva (Casanare)»: la ciudad trae el departamento pegado.
        const place = splitPlace(city);
        return place ? matchMunicipality(place.city, departmentHint ?? place.department) : undefined;
    }
    const dep = matchDepartment(departmentHint);
    if (dep)
        return options.find((m) => m.code.startsWith(dep.code));
    return options.length === 1 ? options[0] : undefined;
}
/**
 * Separa «ciudad + departamento» cuando el texto termina con el nombre de un departamento («MIRAFLORES BOYACÁ»,
 * «Tuluá - Valle del Cauca», «Villanueva (Casanare)», «Bucaramanga, Santander»); undefined si no lo trae.
 */
export function splitPlace(text) {
    if (!text)
        return undefined;
    const words = text.replace(/[()]/g, ' ').replace(/\s+[-–]\s+|,/g, ' ').split(/\s+/).filter(Boolean);
    for (let i = 1; i < words.length; i++) {
        const dep = matchDepartment(words.slice(i).join(' '));
        if (dep)
            return { city: words.slice(0, i).join(' '), department: dep.name };
    }
    return undefined;
}
//# sourceMappingURL=divipola.js.map